<template>
  <div>
    <label v-if="label" :for="id">{{ label }}</label>
    <small v-if="helper" class="form-text form-helper">{{ helper }}</small>
    <ModelSelect
      :id="id"
      ref="input"
      v-bind="$attrs"
      :isDisabled="$attrs.disabled ? $attrs.disabled : false"
      class="form-control w-100"
      :class="{
        success: !errors.length && binded,
        error: errors.length,
      }"
      v-model="binded"
      :options="options"
      @input="$emit('input', binded)"
    />
    <Error v-if="errors.length" :errors="errors" />
  </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select';
import Error from '@/Shared/Inputs/Error';

export default {
  inheritAttrs: false,

  components: {
    Error,
    ModelSelect,
  },

  props: {
    id: {
      type: String,
      default() {
        // eslint-disable-next-line no-underscore-dangle
        return `text-input-${this._uid}`;
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    value: [String, Number],
    label: String,
    helper: String,
    errors: {
      type: Array,
      default: () => [],
    },

    items: {
      type: Array,
      required: true,
    },
    idField: {
      type: String,
      default: 'id',
    },
    nameField: {
      type: String,
      default: 'name',
    },
  },

  data() {
    return {
      binded: this.value,
    };
  },

  watch: {
    value(value) {
      this.binded = value;
    },
  },

  computed: {
    options() {
      const idField = this.idField.split('.');
      const nameField = this.nameField.split('.');

      return this.items.map((item) => {
        // If this has a '.' then we need to
        // check a relationships existance
        let value;

        if (idField.length > 1) {
          const relationship = idField[0];
          const field = idField[1];
          value = item[relationship][field];
        } else {
          value = item[idField];
        }

        let text;
        if (nameField.length > 1) {
          const relationship = nameField[0];
          const field = nameField[1];
          text = item[relationship][field];
        } else {
          text = item[nameField];
        }

        return {
          value,
          text,
        };
      });
    },
  },

  methods: {
    focus() {
      this.$refs.input.focus();
    },
    select() {
      this.$refs.input.select();
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end);
    },
  },
};
</script>
